// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleFeaturedFeed: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleFeaturedFeed
      };
    },
    MOST_CREATIVE_PEOPLE_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
